import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { supabase } from "../supabase/client";
import { useUser } from "../context/Usercontext";

let ListHeader = () => {
  let { isSession, user } = useUser();

  let [currUser, setCurrUser] = useState(null);
  useEffect(() => {
    const getUser = async () => {
      try {
        let sessionActive = await supabase.auth.getSession();
        let userActive = sessionActive.data.session.user;
        setCurrUser(userActive);
      } catch {
        console.log("No user");
      }
    };

    getUser();
  }, []);
  return (
    <ul className="links-components">
      <Link to="/temp">temp</Link>
      {user ? null : <Link to="/login">login</Link>}
      {user ? <Link to="/profile">profile</Link> : null}
    </ul>
  );
};

let Header = function (params) {
  return (
    <motion.div
      initial={{ opacity: 1, scale: 1, y: -100 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="header-component"
    >
      <span>Say facts</span>
      <ListHeader />
    </motion.div>
  );
};

export default Header;
